// ShortcutHelp.jsx
import React, { useState } from "react";
import { ShortcutSheet, useShortcut } from "react-keyhub";

import { ShortcutSheetStyles } from "react-keyhub";
import { MyCustomShortcutSheet } from "./ShortcutsModal";
function ShortcutHelp() {
  const [isOpen, setIsOpen] = useState(false);
  // console.log(isOpen, "isOpenisOpenisOpenisOpenisOpen");

  // Toggle the cheat sheet when the "showShortcuts" shortcut is triggered (e.g. Ctrl+/)
  useShortcut("showShortcuts", () => setIsOpen((open) => !open));

  return (
    <>
      <style>{ShortcutSheetStyles}</style>
      {/* {isOpen && <ShortcutSheet isOpen={isOpen} onClose={() => setIsOpen(false)} layout="sidebar" />} */}
      {isOpen && <MyCustomShortcutSheet isOpen={isOpen} onClose={() => setIsOpen(false)} />}
    </>
  );
}

export default ShortcutHelp;
